import React, { useState } from "react";
import { Button, TextBox, ValidationGroup, Validator } from "devextreme-react";
import styles from "../../../../styles/stylesgenerales";
import { Tooltip } from "devextreme-react/ui/tooltip";
import CarnetImg from "../../../../images/carnet.png";
import validacion from "../../../../helpers/validaciones";
import { validacionIdentidadAction } from "../actions";
// import RutLib from "./../../../../helpers/rut.lib";
import { validarIdentidadUsuario } from "../../../../services/ValidacionIdentidad";
import carnet_frente from "../../../../images/carnet_frente.JPG"
import carnet_detras  from "../../../../images/carnet_detras.JPG"

const Step1 = ({ dispatch, redireccion, flujo }) => {
    const [showTooltip2, setShowTooltip] = useState(false);
    let [showPhoto, setShowPhoto] = useState(false);
  const [rutValue, setRutValue] = useState("");
  const [serieCI, setSerieCI] = useState("");

  //const { handleChange, nextStep, disabled, value, error } = this.props;

  return (
    <div
      className="acceso row"
      style={{ justifyContent: "center", alignItems: "center" }}
    >
      <div className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div style={{ textAlign: "justify" }}>
          <h2
            className="titulo-validacion-cuenta"
            style={{
              textAlign: "center",
              paddingTop: 20,
              marginBottom: "20px",
            }}
          >
            {" "}
            Validación identidad{" "}
          </h2>
          <p style={{ fontSize: "16px" }}>
            A continuación, te solicitaremos tu RUT y número de serie CI para
            validar tu identidad y proteger tus datos. Lo anterior, cumple con
            normativa vigente de protección y confidencialidad de los datos
            personales de las personas y empresas (usuarios) que ingresan a la
            plataforma web, dispuesta en el artículo 19 N°4 de la Constitución
            Política de la República y la Ley N°19.628 sobre Protección de la
            Vida Privada. Los datos solicitados no son almacenados por la ACHS.
          </p>
          <p
            style={{
              fontSize: "14px",
              textAlign: "center",
              marginTop: "10px",
              fontWeight: "bold",
            }}
          >
            Para mayor información, te invitamos a leer las “Términos y
            condiciones” al final del proceso de registro.
          </p>
        </div>
      </div>
      <ValidationGroup className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div
          className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
          style={{ paddingBottom: 15 }}
        >
          <h4>
            <p className="text-left" style={{ marginTop: 11, fontSize: 15 }}>
              Usuario
            </p>
          </h4>

          <TextBox
            id="user"
            placeholder="Rut"
            onValueChanged={(e) => {
              setRutValue(
                e.value &&
                  validacion.formatRut(e.value, {
                    showHyphen: true,
                    showDots: false,
                  })
              );
              sessionStorage.setItem(
                "rutUsuarioActivacion",
                validacion.formatRut(e.value, {
                  showDots: false,
                  showHyphen: true,
                })
              );
            }}
            valueChangeEvent="keyup"
            value={rutValue}
            // onFocusIn={() => setShowTooltip(true)}
            // onFocusOut={() => setShowTooltip(false)}
          >
            <Validator
              validationRules={[
                { type: "required", message: "el rut es requerido" },
                {
                  type: "custom",
                  validationCallback: () => validacion.validateRut(rutValue),
                  message: "El rut es invalido",
                },
              ]}
            />
          </TextBox>

          <h4>
            <p className="text-left" style={{ marginTop: 11, fontSize: 12 }}>
              Sin puntos y con guión{" "}
            </p>
          </h4>
          {/* <span style={{ color: "red", marginTop: 10 }}>{error}</span> */}
        </div>

        <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Tooltip
            visible={showTooltip2}
            contentRender={() => (
              <div>
                <img style={{ height: 320 }} src={CarnetImg} alt="carnet" />
              </div>
            )}
            position="right"
            target="#serialCI"
          />
          <h3>
            <p className="text-left">
              N° de Serie CI <span className="label-green-requerido"> *</span>
            </p>
          </h3>
          <TextBox
            id="serialCI"
            useMaskedValue
            placeholder="Serial CI"
            valueChangeEvent="keyup"
            onValueChanged={(e) => {
              const value = String(e.value).trimStart().trimEnd().replaceAll('.', '');
              sessionStorage.setItem("serialCIActivacion", value);
              setSerieCI(value);
            }}
            value={serieCI}
            maxLength={12}
          >
            <Validator
              validationRules={[
                {
                  type: "required",
                  message: "el numero de serie es requerido",
                },
              ]}
            />
          </TextBox>

          <h4>
            <p className="text-left" style={{ marginTop: 11, fontSize: 12 }}>
              Sin puntos{" "}
            </p>
          </h4>
        </div>

          <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              {
                  showPhoto ? (
                      <div>
                          <button style={styles.fullWidth}onClick={()=>setShowPhoto (false)} >
                              Cerrar
                          </button>
                          <img src={carnet_frente} alt="carnet frente"/>
                          <img src={carnet_detras} alt="carnet detras"/>
                      </div>
                  ) : (
                      <div>
                        <button style={styles.fullWidth}
                                onClick={()=>setShowPhoto (true)}>
                            ¿Donde encontrar estos datos?
                        </button>
                      </div>
                  )
              }
          </div>

        <div
          className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
          style={{ textAlign: "center" }}
        >
          <Button
            style={styles.fullWidth}
            text="Siguiente"
            type="default"
            onClick={(e) => {
              const result = e.validationGroup.validate();
              result.isValid &&
                dispatch(
                  validacionIdentidadAction(
                    redireccion,
                    validarIdentidadUsuario,
                    flujo
                  )
                );
            }}
          />
        </div>
      </ValidationGroup>
    </div>
  );
};

export default Step1;
